if (!customElements.get('dope-honorable-lookbook')) {
  customElements.define('dope-honorable-lookbook', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.profiles = [...this.querySelectorAll('[data-hm-profile]')];
      this.index = this.querySelector('[data-hm-index]');
      this.viewer = this.querySelector('[data-hm-viewer]');
      this.fullImage = this.querySelector('[data-hm-full-image]');
      this.onHash = () => this.showProfile(true);
      this.addEventListener('click', this.onClick = event => this.handleClick(event));
      this.addEventListener('play', this.onPlay = event => {
        this.querySelectorAll('video').forEach(video => { if (video !== event.target) video.pause(); });
        this.pauseExternalPlayers();
        const button = event.target.closest('.hm__media')?.querySelector('[data-hm-play]');
        if (button) button.hidden = true;
      }, true);
      this.onPause = event => {
        const button = event.target.closest('.hm__media')?.querySelector('[data-hm-play]');
        if (button) button.hidden = false;
      };
      this.addEventListener('pause', this.onPause, true);
      this.addEventListener('ended', this.onPause, true);
      window.addEventListener('hashchange', this.onHash);
      this.viewer.addEventListener('close', this.onClose = () => {
        this.fullImage.removeAttribute('src');
        document.documentElement.style.overflow = this.previousOverflow ?? '';
        if (this.opener?.isConnected) this.opener.focus({preventScroll:true});
      });
      this.viewer.addEventListener('keydown', this.onViewerKey = event => {
        if (event.key === 'ArrowRight') { event.preventDefault(); this.showPhoto(this.photoIndex + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.showPhoto(this.photoIndex - 1); }
      });
      this.querySelectorAll('[data-hm-filters]').forEach(filters => { filters.hidden = false; });
      this.querySelectorAll('[data-hm-play]').forEach(button => { button.hidden = false; });
      this.showProfile(false);
    }
    disconnectedCallback() {
      window.removeEventListener('hashchange', this.onHash);
      if (this.viewer?.open) this.viewer.close();
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('play', this.onPlay, true);
      this.removeEventListener('pause', this.onPause, true);
      this.removeEventListener('ended', this.onPause, true);
      this.viewer?.removeEventListener('close', this.onClose);
      this.viewer?.removeEventListener('keydown', this.onViewerKey);
      this.initialized = false;
    }
    pauseFilms(container = this) {
      container.querySelectorAll('video').forEach(video => video.pause());
      this.pauseExternalPlayers(container);
    }
    pauseExternalPlayers(container = this) {
      container.querySelectorAll('[data-hm-external-frame]').forEach(frame => {
        const opener = frame.parentElement.querySelector('[data-hm-youtube]');
        if (opener) opener.hidden = false;
        frame.remove();
      });
    }
    showProfile(moveFocus) {
      const key = window.location.hash.slice(1);
      const profile = this.profiles.find(item => item.dataset.hmProfile === key);
      if (this.viewer.open) this.viewer.close();
      this.pauseFilms();
      this.index.hidden = !!profile;
      this.profiles.forEach(item => { item.hidden = item !== profile; });
      if (profile) this.dataset.hmActive = key;
      else delete this.dataset.hmActive;
      this.querySelectorAll('[data-hm-person]').forEach(link => {
        if (link.dataset.hmPerson === key) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
      if (moveFocus) {
        const target = profile?.querySelector('h2') ?? this.index.querySelector(`[data-hm-person="${this.lastProfile || ''}"]`) ?? this.index.querySelector('a');
        target?.focus({preventScroll:true});
        (profile ?? this).scrollIntoView({block:'start', behavior:'instant'});
      }
    }
    handleClick(event) {
      const control = event.target.closest('a,button');
      if (!control || !this.contains(control)) return;
      if (control.matches('[data-hm-person],[data-hm-back]')) {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        this.lastProfile = this.dataset.hmActive || control.dataset.hmPerson;
        if (window.location.hash === control.hash) { event.preventDefault(); this.showProfile(true); }
      }
      if (control.matches('[data-hm-filter]')) {
        const profile = control.closest('[data-hm-profile]');
        const kind = control.dataset.hmFilter;
        this.pauseFilms(profile);
        profile.querySelectorAll('[data-hm-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === control)));
        profile.querySelectorAll('[data-hm-kind]').forEach(item => { item.hidden = kind !== 'all' && item.dataset.hmKind !== kind; });
      }
      if (control.matches('[data-hm-play]')) {
        const video = control.closest('.hm__media')?.querySelector('video');
        video?.play().catch(() => { control.hidden = false; });
      }
      if (control.matches('[data-hm-youtube]')) {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        const id = control.dataset.hmYoutube;
        if (!/^[a-zA-Z0-9_-]{11}$/.test(id)) return;
        const configuredStart = Number(control.dataset.hmStart);
        const start = Number.isSafeInteger(configuredStart) && configuredStart > 0 ? Math.min(configuredStart, 86400) : 0;
        event.preventDefault();
        this.pauseFilms();
        const frame = document.createElement('iframe');
        frame.dataset.hmExternalFrame = '';
        frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0${start ? `&start=${start}` : ''}`;
        frame.title = control.dataset.hmTitle;
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        control.hidden = true;
        control.parentElement.appendChild(frame);
      }
      if (control.matches('[data-hm-photo]') && typeof this.viewer.showModal === 'function') {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        this.pauseFilms();
        this.opener = control;
        this.photos = [...control.closest('[data-hm-profile]').querySelectorAll('[data-hm-photo]')];
        this.showPhoto(this.photos.indexOf(control));
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.viewer.showModal();
      }
      if (control.matches('[data-hm-close]')) this.viewer.close();
      if (control.matches('[data-hm-previous]')) this.showPhoto(this.photoIndex - 1);
      if (control.matches('[data-hm-next]')) this.showPhoto(this.photoIndex + 1);
    }
    showPhoto(index) {
      if (!this.photos?.length || index < 0 || index >= this.photos.length) return;
      this.photoIndex = index;
      const photo = this.photos[index];
      const thumbnail = photo.querySelector('img');
      const width = thumbnail.naturalWidth || thumbnail.width;
      const height = thumbnail.naturalHeight || thumbnail.height;
      if (width > 0 && height > 0) {
        this.viewer.style.setProperty('--hm-viewer-ratio', width / height);
        this.fullImage.width = width;
        this.fullImage.height = height;
      }
      this.fullImage.src = photo.href;
      this.fullImage.alt = thumbnail.alt;
      this.querySelector('[data-hm-full-caption]').textContent = photo.dataset.hmCaption;
      this.querySelector('[data-hm-counter]').textContent = `${index + 1} / ${this.photos.length}`;
      this.querySelector('[data-hm-previous]').disabled = index === 0;
      this.querySelector('[data-hm-next]').disabled = index === this.photos.length - 1;
    }
  });
}
